module.exports = __webpack_public_path__ + "img/editor-header.621252a9.svg";